<template>
  <div class="companyFocus-page margin-l-20 margin-r-20">
    <div class="company-index-header">
      <el-select v-model="value" placeholder="请选择"  size="small" @change="getAll" class="margin-l-20">
        <el-option v-for = 'item in typeList'  :key="item.value" :label="item.value" :value="item.value"></el-option>
      </el-select>
      <el-date-picker class="margin-l-20" v-model="companyForm.times" type="month" placeholder="选择月" :clearable="false"
                      format="yyyy-MM" value-format="yyyy-MM" @change="getAll" :picker-options="pickerOptions"></el-date-picker>
      <el-input placeholder="公司名称、法人、社会信用代码" v-model="companyForm.keyWord" prefix-icon="el-icon-search" clearable size="small"
                style="width: 320px;margin-top: 12px;float: right;margin-right: 20px">
        <el-button slot="append" class="lookFor" @click="getAll">查询</el-button>
      </el-input>
    </div>
    <div class="margin-t-20 margin-b-20 font-16" style="color: #2c3e50">
      截止{{companyForm.times}},共计监测企业数{{companyTotal.companyNum}}家,店铺数{{companyTotal.shopNum}}家
<!--      ，当期网络零售额{{companyTotal.money}}万元，累计网络零售额{{companyTotal.ljMoney}}万元-->
<!--      <div class="float-right cursor-pointer" @click="downCompany()">-->
<!--        <i class="el-icon-download font-18 text-ff7f00"></i><span class="font-18">导出</span>-->
<!--      </div>-->
    </div>
    <el-card class="companyFocus-content">
      <el-table :data="companyList" width="480px" class="border-DEDEDE" stripe @row-click="tableDetail">
        <el-table-column prop="hisRanking" label="往年排名" align="center" width="100" ></el-table-column>
        <el-table-column prop="companyname" label="企业名称" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="企业综合指数" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.comindexShow || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="opername" label="法定代表人" width="120" align="center"></el-table-column>
        <el-table-column prop="address" label="注册地址" width="250" show-overflow-tooltip align="center"></el-table-column>
        <!--        <el-table-column prop="econkind" label="企业类型" show-overflow-tooltip align="center"></el-table-column>-->
        <!--        <el-table-column prop="salesofmonthstr" label="当期网络零售额（万元）" width="200" align="center"></el-table-column>-->
        <el-table-column label="当期网络零售额（万元）" align="center">
          <template slot-scope="scope">
            {{ scope.row.salesofmonthstr || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="累计网络零售额（万元）" align="center">
          <template slot-scope="scope">
            {{ scope.row.salesofyearstr || '--' }}
          </template>
        </el-table-column>
<!--        <el-table-column label="累计网络零售额排名" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.ranking || '&#45;&#45;' }}-->
<!--            <i v-if="scope.row.ranking" :class="[scope.row.hisRanking-scope.row.ranking > 0?'el-icon-top text-FF7D7D ':'el-icon-bottom text-72f1a5']">-->
<!--              {{ scope.row.hisRanking - scope.row.ranking }}-->
<!--            </i>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="keyno" label="统一社会信用代码" align="center"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next"
        :total="total" :page-size="pageSize" @current-change="handleCurrentChange" class="margin-t-30 text-center">
      </el-pagination>
    </el-card>
    <p class=" margin-r-20 font-14 text-8A8A8A margin-t-20">
      注： <br/>
      1.重点企业特指往年累计网络零售额TOP100的企业。<br/>
      2.网络零售额和累计排名为空可能原因如下： <br/>
      （1）该企业电商店铺关闭。  <br/>
      （2）该企业营业执照变更为外地，不属于江西企业。<br/>
      （3）该企业已注销。
    </p>
  </div>
</template>

<script>
    export default {
        name: "companyFocus",
      data () {
        return {
          isHave: false,
          moneyValue: '',
          input: '',
          restaurants: [],
          companyTotal:{},//宏观数据
          state: '',
          salesTable: {},//重点赣企销售额排行
          yoyTable: {},//重点赣企增速排行
          timeout: null,
          value:"九江市",
          typeList:[{'value':'九江市'},{'value':'柴桑区'},{'value':'德安县'},{'value':'都昌县'},{'value':'共青城市'},
            {'value':'湖口县'},{'value':'濂溪区'},{'value':'庐山市'},{'value':'彭泽县'},{'value':'瑞昌市'},{'value':'武宁县'},
            {'value':'修水县'},{'value':'浔阳区'},{'value':'永修县'}],
          total: 100,
          currentPage: 1, //初始页
          pageSize: 10,    //    每页的数据
          companyForm: {times: '', money: '全部', keyWord: '', sMoney: '', eMoney: ''},
          companyList: [],
          pickerOptions: {
            disabledDate: (time) => {
              // console.log(time.getMonth());
              let nowDate = new Date()
              let day = nowDate.getDate()
              nowDate.setDate(1);
              if (day > 14) {
                if(nowDate.getMonth()==0){
                  nowDate.setMonth(11);
                  nowDate.setFullYear(nowDate.getFullYear()-1);
                }
                else{
                  nowDate.setMonth(nowDate.getMonth()-1);
                }
              } else {
                if(nowDate.getMonth()==0){
                  nowDate.setMonth(10);
                  nowDate.setFullYear(nowDate.getFullYear()-1);
                }
                else if(nowDate.getMonth()==1){
                  nowDate.setMonth(11);
                  nowDate.setFullYear(nowDate.getFullYear()-1);
                }
                else{
                  nowDate.setMonth(nowDate.getMonth()-2);
                }
              }
              if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
            }
          },
        }
      },
      created () {
        this.$emit('public_header', true)
      },
      watch:{
        activeCity: {
          handler(newValue, oldValue) {
            //父组件param对象改变会触发此函数
            this.getAll()
            this.getInvestInfo()
            this.getAllInfo()
            this.getCompanyByInfo()
          },
          deep: true
        }
      },
      methods: {
        handleCurrentChange: function (currentPage) {
          this.currentPage = currentPage
          this.getCompanyByInfo()
        },
        tableDetail(row){
          this.goToDetail(row.id)
        },

        getAll(){
          this.getAllInfo()
          this.getCompanyByInfo()
        },
        getInvestInfo () {
          if (this.moneyValue == '自定义') {
            this.isHave = true
          }
        },
        aaa () {
          this.isHave = true
          console.dir(this.isHave)
        },
        //关键字模糊搜索企业
        getCompanyByInfo () {
          this.$http.get(this.header + '/importantCompany/importantSearch', {
            params: {
              times: this.companyForm.times,
              limit: this.pageSize,
              page: this.currentPage,
              district: this.value,
              keyWord: this.companyForm.keyWord,
              sMoney: this.companyForm.sMoney,
              eMoney: this.companyForm.eMoney
            }
          }).then(res => {
            if (res.data.code == 0) {
              if (res.data.page) {
                this.companyList = res.data.page.list
                this.total = res.data.page.totalCount
              }
            } else {
              this.$alert(res.data.msg)
            }

          })
        },
        downCompany () {
          // this.$router.push(this.header+'/qyjc/exportXlsx?'+'type='+type+'&index_type='+this.chooseType+'&times='+this.allForm.times+'&platform='+platform)
          window.open(this.header+'/importantCompany/exportXlsx?'+'keyWord='+this.companyForm.keyWord+'&city='+this.companyForm.city+'&times='+this.companyForm.times);
        },
        //企业库概览信息
        getAllInfo () {
          this.$http.get(this.header + '/importantCompany/importantCompanyTotal', {
            params: {
              times: this.companyForm.times,
            }
          }).then(res => {
            if (res.data.code == 0) {
              if (res.data.total) {
                this.companyTotal = res.data.total
              }
            } else {
              this.$alert(res.data.msg)
            }

          })
        },
        //选择近1个月
        oneMonth (val) {
          let dataArr = []
          let data = new Date()
          let day = data.getDate()
          data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
          for (var i = 0; i < 3; i++) {
            data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
            var m = data.getMonth() + 1
            m = m < 10 ? '0' + m : m
            dataArr.push(data.getFullYear() + '-' + (m))
          }
          if (day > 14) {
            this.companyForm.times = dataArr[1]
          } else {
            this.companyForm.times = dataArr[2]
          }
          this.getCompanyByInfo()
          this.getAllInfo()
        },
        //返回输入建议的方法，仅当你的输入建议数据 resolve 时，通过调用 callback(data:[]) 来返回它
        querySearchAsync (queryString, cb) {
          this.state = queryString
          this.$http.get(this.header + '/gpjc/gq/catalogue', {
            params: {
              keyWord: this.state
            }
          }).then(res => {
            if (res.data.code == 0) {
              if (res.data.list) {
                this.restaurants = res.data.list
                // var results = queryString ? this.restaurants.filter(this.createStateFilter(queryString)) : this.restaurants;
                // let results = queryString ? this.restaurants.filter(this.createStateFilter(queryString)) : this.restaurants;
                console.log(this.restaurants)
                cb(this.restaurants)
              }
            } else {
              this.$alert(res.data.msg)
            }

          })

        },

        //点击选中建议项时触发
        goToDetail (id) {
          let page = this.$router.resolve({
            name: 'focusDetail',
            query: {
              id: id
            }
          })
          window.open(page.href, '_blank')
          // this.$router.push({
          //   path: '/companyDetail',
          //   query: {
          //     id: id
          //   }
          // })
        }
      },
      mounted () {
        this.oneMonth()
        // this.restaurants = this.loadAll()
        // this.getCompanyTop()
      }
    }
</script>

<style>
  .companyFocus-page .company-index-header {
    text-align: left;
    margin-bottom: 8px;
    height: 54px;
    line-height: 54px;
    background: white;
    /*border: 1px solid rgba(100, 156, 238, 0.4);*/
    box-shadow: 0px 6px 7px 4px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    color: #6589C5;
  }

  .companyMoney-choose .el-input__inner {
    padding: 0 5px;
    height: 26px;
  }

  /*.company-index-page .company-index-header ul li:nth-child(5):hover .bbb{*/
  /*  display: block;*/
  /*}*/
  .el-select-dropdown__item:nth-child(5):hover {
    position: relative;
  }

  .bbb {
    display: none;
    position: absolute;
    top: 0;
    left: 100%;
    z-index: 100
  }

  .el-select-dropdown__item:nth-child(5):hover .bbb {
    /*display: block;*/
  }

  .el-select-dropdown__item:nth-child(5):hover {

    /*background-color: red;*/
  }

  .companyFocus-page .el-select .el-input__inner,.companyFocus-page .el-date-editor--month .el-input__inner {
    height: 30px;
    width: 130px;
    background-color: rgba(255, 255, 255, 1) !important;
    /*border-radius: 25px;*/
    color: #6B7991 !important;
  }

  .companyFocus-page .company-index-content h2 {
    font-size: 24px;
    /* font-family: Source Han Sans CN; */
    font-weight: bold;
    color: #666;
  }

  .companyFocus-page .company-index-content .list span {
    margin-right: 30px;
    color: #666;
  }

  .companyFocus-page .el-autocomplete {
    width: 100%;
  }

  .companyFocus-page .el-autocomplete-suggestion {
    height: 500px;
  }

  .companyFocus-page .el-autocomplete-suggestion__wrap {
    max-height: 700px;
  }

  .companyFocus-page .rank .el-card {
    background-color: #262A31 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/companyFocus.vue